var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    commission: null,
    initialData: null,
};
export var commissionModuleSlice = createSlice({
    name: 'commissionModule',
    initialState: initialState,
    reducers: {
        setCommission: function (state, action) {
            state.commission = action.payload;
            state.initialData = action.payload;
        },
        updateCommissionInfo: function (state, action) {
            if (state.commission) {
                state.commission = __assign(__assign({}, state.commission), action.payload);
            }
        },
        addAirlineCommission: function (state, action) {
            var _a, _b;
            (_b = (_a = state.commission) === null || _a === void 0 ? void 0 : _a.airlines_commissions) === null || _b === void 0 ? void 0 : _b.push(action.payload);
        },
        removeAirlineCommission: function (state, action) {
            var _a, _b, _c;
            if ((_a = state.commission) === null || _a === void 0 ? void 0 : _a.airlines_commissions) {
                state.commission.airlines_commissions =
                    (_c = (_b = state.commission) === null || _b === void 0 ? void 0 : _b.airlines_commissions) === null || _c === void 0 ? void 0 : _c.filter(function (airline) { return airline.id !== action.payload.id; });
            }
        },
        updateAirlineCommission: function (state, action) {
            var _a;
            if ((_a = state.commission) === null || _a === void 0 ? void 0 : _a.airlines_commissions) {
                state.commission.airlines_commissions =
                    state.commission.airlines_commissions.map(function (commission) {
                        if (commission.id === action.payload.id) {
                            return action.payload;
                        }
                        return commission;
                    });
            }
        },
    },
});
export var commissionModuleActions = commissionModuleSlice.actions;
export var commissionModuleReducer = commissionModuleSlice.reducer;
